import * as React from 'react';

import { Icon } from '@rbilabs/components-library';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import theme from './theme';

const StyledLink = styled(Link)`
  border-bottom: 1px solid ${Styles.color.grey.four};
  width: 100%;
  font-family: ${Styles.fontFamily.body};
  text-decoration: none;
  color: ${theme.arrowLinkLabelColor};
  padding: 20px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ArrowLink: React.FC<React.ComponentProps<typeof StyledLink>> = ({
  children,
  ...props
}) => (
  <StyledLink {...props}>
    {children}
    <Icon icon="next" color="icon-default" width="16px" aria-hidden />
  </StyledLink>
);
